import { render, staticRenderFns } from "./CulturalListYjj.vue?vue&type=template&id=6e7c1cda&scoped=true&"
import script from "./CulturalListYjj.vue?vue&type=script&lang=js&"
export * from "./CulturalListYjj.vue?vue&type=script&lang=js&"
import style0 from "./CulturalListYjj.vue?vue&type=style&index=0&id=6e7c1cda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c1cda",
  null
  
)

export default component.exports